import iView from 'view-design';
// import iView from 'iview'
import store from '@/plugins/store';
import router from '@/plugins/router';
import global from '@/global/global';
import api from '@/plugins/api';
import Vue from 'vue';
/* export function routerBeforeEachFunc (to, from, next) {
  // 页面拦截、权限处理
  iView.LoadingBar.start()
  // 拦截每一个方法、页面/例外登录页面
  let loginPage = 'loginPage'
  if (to.name !== loginPage && !account.username) { // 如果是未登录状态,并且不是要进入登录页面的话 !store.getters.userInfo.username
    store.dispatch('login').then(() => {
      router.push({
        path: to.path
      })
    })
  } else {
    next()
  }
} */
function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return (false);
}

export function routerBeforeEachFunc_bak(to, from, next) {
  // location.href = "http://127.0.0.1:2080/vue/token/authUrl?url="+decodeURIComponent("https://127.0.0.1:8080/home/index");
  // 页面拦截、权限处理
  iView.LoadingBar.start();
  // 拦截每一个方法、页面/例外登录页面
  let username = sessionStorage.getItem('username'); // 用户登录信息
  console.log(username);
  if (username === null) {
    if (!getQueryVariable('action')) {
      location.href = global.OAUTH2_URL;
    } else {
      api['account/getTokenUserInfo']().then(data => {
        sessionStorage.setItem('username', data.name);
        login(1, to, next);
      }).catch(error => {
        console.log(error);
        location.href = global.OAUTH2_URL;
      });
    }
  } else {
    api['account/getTokenUserInfo']().then(data => {
      login(0, to, next);
    }).catch(error => {
      console.log(error);
      location.href = global.OAUTH2_URL;
    });
  }
}
function login(val, to, next) {
  if (val === 0) {
    localStorage.setItem('userInfo', JSON.stringify({userId: sessionStorage.getItem('username'), password: 'oss登入'}));
    // var options = {
    //   apiUrl: WebIM.config.apiURL,
    //   user: sessionStorage.getItem('username'),
    //   pwd: payload.password,
    //   appKey: WebIM.config.appkey
    // };
    // WebIM.conn.open(options);
    if (!store.getters.menuList || to.name === null) {
      // 先获取登录信息，后跳转业务界面
      store.dispatch('login').then(() => {
        router.push({
          path: to.path
        });
      });
    } else {
      next();
    }
  } else {
    store.dispatch('login', null).then(res => {
      if (res) {
        localStorage.setItem('userInfo', JSON.stringify({userId: sessionStorage.getItem('username'), password: 'oss登入'}));
        router.push(
          {
            name: 'home',
            params: {}
          });
        store.commit('setFullScreen', true);
      } else {
        Vue.$Modal.warning({
          title: '错误',
          content: '用户名或密码错误'
        });
      }
    }).finally(() => {

    });
  }
}
export function routerBeforeEachFunc(to, from, next) {
  // 页面拦截、权限处理
  iView.LoadingBar.start();
  // if (to.name === global.AUTH_PAGE_NAME || to.fullPath.indexOf(global.AUTH_PAGE_NAME) !== -1) {
  //   next();
  //   return;
  // }
  // 拦截每一个方法、页面/例外登录页面
  let username = sessionStorage.getItem('username'); // 用户登录信息
  console.log('------------current page url:' + to.name);
  console.log('current username :' + username);
  // TODO 修改为adminLogin才可以通过访问，不然都会重定向到登录页
  let loginPage = global.LOGIN_PAGE_NAME;
  if (!username && to.name !== loginPage) { // 1.登录信息失效(且非登录页面)，统一跳转用户登录界面
    let {
      name,
      params,
      query
    } = {};
    // name = 'loginPage'
    name = loginPage;
    router.push({
      name,
      params,
      query
    });
  } else {
    next();
  }
}

export function routerAfterEachFunc(to) {
  iView.LoadingBar.finish();
}
